import { useCallback, useEffect, useRef, useState } from "react";

export const useIsOverflow = (): [boolean, (node: Element | null) => void] => {
  const [isOverflow, setIsOverflowing] = useState(false);
  const timeoutIdRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, []);

  const refHandler = useCallback((node: Element | null) => {
    if (!node) {
      return;
    }

    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }

    timeoutIdRef.current = setTimeout(() => {
      if (!isMountedRef.current) return;
      // if many children
      if (node.children?.length) {
        // just look at the last child
        setIsOverflowing(
          !node.lastElementChild
            ? false
            : node.lastElementChild.clientHeight <
                node.lastElementChild.scrollHeight ||
                node.lastElementChild.clientWidth <
                  node.lastElementChild.scrollWidth
        );
      } else {
        // if a single child
        setIsOverflowing(
          node.clientHeight < node.scrollHeight ||
            node.clientWidth < node.scrollWidth
        );
      }
    }, 1);
  }, []);

  return [isOverflow, refHandler];
};
